import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-step-orange",
  "use": "icon-arrow-up-step-orange-usage",
  "viewBox": "0 0 33 22",
  "content": "<symbol viewBox=\"0 0 33 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up-step-orange\">\n<rect width=\"33\" height=\"4\" transform=\"matrix(1 0 0 -1 0 7.06616)\" fill=\"#999999\" />\n<rect width=\"33\" height=\"4\" transform=\"matrix(1 0 0 -1 0 4)\" fill=\"#FF9200\" />\n<path d=\"M16.5 21.0662V9.06616M16.5 9.06616L24 13.9412M16.5 9.06616L9 13.9412\" stroke=\"#999999\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol